import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getCurrentUser } from '../api/api';
import { useAuth } from '../context/authContext';

export const useUser = () => {
    const { user: authUser, isAuthenticated } = useAuth();

    const { data: user, isLoading, error, refetch } = useQuery({
        queryKey: ['user'],
        queryFn: getCurrentUser,
        enabled: isAuthenticated,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        // Use the auth user as initial data to avoid loading state
        initialData: authUser,
    });

    return {
        user: user || authUser,
        isLoading,
        error,
        refetch
    };
};

export const useUpdateUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: getCurrentUser,
        onSuccess: (updatedUser) => {
            // Update the user cache
            queryClient.setQueryData(['user'], updatedUser);
        },
        onError: (error) => {
            console.error('Failed to update user data:', error);
        }
    });
};
